const divvyAdminSidebar = {
  namespaced: true,
  state: () => ({
    ActiveItem: "addSupplier",
    ActiveMenu: "",
  }),
  getters: {
    getActiveItem(state) {
      return state.ActiveItem;
    },
    getActiveMenu(state) {
      return state.ActiveMenu;
    },
  },
  actions: {
    setActive({ commit }, menu) {
      console.log(menu, 'from store')
      commit("SET_MENU_ITEM", menu.activeMenuItem);
      commit("SET_MENU", menu.activeMenu);
    },
    fetchUserModules({ commit }) {
      return new Promise((resolve, reject) => {
        getSidebarModules()
          .then((resp) => {
            commit("SET_USER_MODULES", resp);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mutations: {
    SET_MENU_ITEM: (state, menuItem) => {
      state.ActiveItem = menuItem;
    },
    SET_MENU: (state, menu) => {
      state.ActiveMenu = menu;
    },
  },
};

export default divvyAdminSidebar;
